console.log('animationfile');

AOS.init();
      $(window).scroll(function() {
        var product_section = "#shopify-section-template--21038767046949__1e047568-8251-45e2-82c4-61621ebcfdb6";
        $(product_section).each(function() {
          var elem_first = $(`${product_section} .title`);
          var elem_second = $(`${product_section} .ishi-featured-product-tab`);
          // Set the data-aos-duration attribute
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1000);
          elem_first.attr('data-aos-once', 'true');

          elem_second.attr('data-aos', 'fade-up');
          elem_second.attr('data-aos-duration', 1000);
          elem_second.attr('data-aos-once', 'true');
          setTimeout(() => {
              AOS.init();
          });
        });


        var gift_section = "#shopify-section-template--21038767046949__b68175d7-38a4-451f-8a4b-c591f1972a93";
        $(gift_section).each(function() {
          var elem_first = $(`${gift_section} .title`);
          var elem_second = $(`${gift_section} .ishi-featured-product-tab`);
          // Set the data-aos-duration attribute
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1000);
          elem_first.attr('data-aos-once', 'true');

          elem_second.attr('data-aos', 'fade-up');
          elem_second.attr('data-aos-duration', 1000);
          elem_second.attr('data-aos-once', 'true');
          setTimeout(() => {
              AOS.init();
          });
        });

        var oils_gift_section = "#shopify-section-template--21565815882021__313741d1-6de1-4443-bd1e-7f7fef1c593a";
        $(oils_gift_section).each(function() {
          var elem_first = $(`${oils_gift_section} .title`);
          var elem_second = $(`${oils_gift_section} .ishi-featured-product-tab`);
          // Set the data-aos-duration attribute
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1000);
          elem_first.attr('data-aos-once', 'true');

          elem_second.attr('data-aos', 'fade-up');
          elem_second.attr('data-aos-duration', 1000);
          elem_second.attr('data-aos-once', 'true');
          setTimeout(() => {
              AOS.init();
          });
        });

        var home_banner = "#shopify-section-template--21038767046949__33cd25ef-58b5-4320-b64b-9c3d1a620fb0";
        $(home_banner).each(function() {
          var elem_first = $(`${home_banner} .image-container`);
          // Set the data-aos-duration attribute
          elem_first.attr('data-aos', 'zoom-out');
          elem_first.attr('data-aos-duration', 2000);
          elem_first.attr('data-aos-once', 'true');
          
          setTimeout(() => {
              AOS.init();
          });
        });

        var p_banner = "#shopify-section-template--21038767243557__69a5015c-96bd-4818-989c-396387f1a20c";
        $(p_banner).each(function() {
          var elem_first = $(`${p_banner} .image-container`);
          // Set the data-aos-duration attribute
          elem_first.attr('data-aos', 'zoom-out');
          elem_first.attr('data-aos-duration', 2000);
          elem_first.attr('data-aos-once', 'true');
          
          setTimeout(() => {
              AOS.init();
          });
        });

        var map_banner = "#shopify-section-template--21038767276325__625a3f46-eccd-468f-a4b6-ec618402abae";
        $(map_banner).each(function() {
          var elem_first = $(`${map_banner} .image-container`);
          // Set the data-aos-duration attribute
          elem_first.attr('data-aos', 'zoom-out');
          elem_first.attr('data-aos-duration', 2000);
          elem_first.attr('data-aos-once', 'true');
          // elem_first.attr('data-aos-offset', 100);
          
          setTimeout(() => {
              AOS.init();
          });
        });

        var mob_section = "#shopify-section-template--21038767046949__0faef658-ba6a-4c61-a587-0b3f1fe71dbc";
        $(mob_section).each(function() {
          var elem_first = $(`${mob_section} .aboutus-information`);
          // Set the data-aos-duration attribute
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');

          setTimeout(() => {
              AOS.init();
          });
        });

        var ghee_mob_section = "#shopify-section-template--21038767046949__10b39d6a-3690-4e05-b96d-a741da76c72d";
        $(ghee_mob_section).each(function() {
          var elem_first = $(`${ghee_mob_section} .aboutus-information`);
          // Set the data-aos-duration attribute
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');

          setTimeout(() => {
              AOS.init();
          });
        });

        var packaging_section = "#shopify-section-template--21520726786341__867d6539-8e7c-498f-a2ef-1e4c0c6476f9";
        $(packaging_section).each(function() {
          var elem_first = $(`${packaging_section} .aboutus-information`);
          // Set the data-aos-duration attribute
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');
          elem_first.attr('data-aos-offset', '100');

          setTimeout(() => {
              AOS.init();
          });
        });
      
      var oe_section = "#shopify-section-template--21038767309093__e2a7ed24-18e9-4eac-8022-83af8ebe989b";
        $(oe_section).each(function() {
          var elem_first = $(`${oe_section} .aboutus-information`);
          // Set the data-aos-duration attribute
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');
          elem_first.attr('data-aos-offset', '100');

          setTimeout(() => {
              AOS.init();
          });
        });

       var a2_section = "#shopify-section-template--21038767309093__40d89355-ac43-433f-be5b-4a970e75009a";
        $(a2_section).each(function() {
          var elem_first = $(`${a2_section} .aboutus-information`);
          // Set the data-aos-duration attribute
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');
          elem_first.attr('data-aos-offset', '100');

          setTimeout(() => {
              AOS.init();
          });
        });

      var biona_section = "#shopify-section-template--21038767309093__74d8483b-281c-4ec6-b87c-de2720dfb0e8";
        $(biona_section).each(function() {
          var elem_first = $(`${biona_section} .aboutus-information`);
          // Set the data-aos-duration attribute
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');
          elem_first.attr('data-aos-offset', '100');

          setTimeout(() => {
              AOS.init();
          });
        });

      var biona_section = "#shopify-section-template--21038767472933__def0f4d0-f76e-47e7-9a1b-96e1e1a9c42c";
        $(biona_section).each(function() {
          var elem_first = $(`${biona_section} .aboutus-information`);
          // Set the data-aos-duration attribute
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');
          elem_first.attr('data-aos-offset', '100');

          setTimeout(() => {
              AOS.init();
          });
        });

      var biona_section = "#shopify-section-template--21038767407397__def0f4d0-f76e-47e7-9a1b-96e1e1a9c42c";
        $(biona_section).each(function() {
          var elem_first = $(`${biona_section} .aboutus-information`);
          // Set the data-aos-duration attribute
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');
          elem_first.attr('data-aos-offset', '100');

          setTimeout(() => {
              AOS.init();
          });
        });

      var biona_section = "#shopify-section-template--21038767440165__def0f4d0-f76e-47e7-9a1b-96e1e1a9c42c";
        $(biona_section).each(function() {
          var elem_first = $(`${biona_section} .aboutus-information`);
          // Set the data-aos-duration attribute
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');
          elem_first.attr('data-aos-offset', '100');

          setTimeout(() => {
              AOS.init();
          });
        });

      var biona_section = "#shopify-section-template--21038767571237__def0f4d0-f76e-47e7-9a1b-96e1e1a9c42c";
        $(biona_section).each(function() {
          var elem_first = $(`${biona_section} .aboutus-information`);
          // Set the data-aos-duration attribute
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');
          elem_first.attr('data-aos-offset', '100');

          setTimeout(() => {
              AOS.init();
          });
        });

      var biona_section = "#shopify-section-template--21038767604005__def0f4d0-f76e-47e7-9a1b-96e1e1a9c42c";
        $(biona_section).each(function() {
          var elem_first = $(`${biona_section} .aboutus-information`);
          // Set the data-aos-duration attribute
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');
          elem_first.attr('data-aos-offset', '100');

          setTimeout(() => {
              AOS.init();
          });
        });

       var biona_section = "#shopify-section-template--21038767505701__def0f4d0-f76e-47e7-9a1b-96e1e1a9c42c";
        $(biona_section).each(function() {
          var elem_first = $(`${biona_section} .aboutus-information`);
          // Set the data-aos-duration attribute
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');
          elem_first.attr('data-aos-offset', '100');

          setTimeout(() => {
              AOS.init();
          });
        });

        var p_richtext = "#shopify-section-template--21038767243557__24d7fefa-330e-468f-b2cb-76c115a55bf1";
        $(p_richtext).each(function() {
          var elem_first = $(`${p_richtext} .rich-text`);
          // Set the data-aos-duration attribute
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');

          setTimeout(() => {
              AOS.init();
          });
        });

      var oil2_richtext = "#shopify-section-template--21038767309093__8db63b07-fdab-4c9f-8793-911ae00cf7d1";
        $(oil2_richtext).each(function() {
          var elem_first = $(`${oil2_richtext} .rich-text`);
          // Set the data-aos-duration attribute
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');

          setTimeout(() => {
              AOS.init();
          });
        });

      var ghee_richtext = "#shopify-section-template--21038767309093__611b1227-c826-4f82-86f0-080a53f48c6a";
        $(ghee_richtext).each(function() {
          var elem_first = $(`${ghee_richtext} .rich-text`);
          // Set the data-aos-duration attribute
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');

          setTimeout(() => {
              AOS.init();
          });
        });

      var brief_richtext = "#shopify-section-template--21038767309093__6f4a1be4-94cb-4b3d-9b8c-6142c761c56f";
        $(brief_richtext).each(function() {
          var elem_first = $(`${brief_richtext} .rich-text`);
          // Set the data-aos-duration attribute
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');

          setTimeout(() => {
              AOS.init();
          });
        });

        var ghee_gift_section = "#shopify-section-template--21038767505701__7282d07c-aa00-45ae-be70-34a000600f59";
        $(ghee_gift_section).each(function() {
          
          var elem_zero = $(`${ghee_gift_section} .sub-title`);
          var elem_first = $(`${ghee_gift_section} .title`);
          var elem_second = $(`${ghee_gift_section} .ishi-featured-product-tab`);
        
          // Set the data-aos-duration attribute
          elem_zero.attr('data-aos', 'fade-up');
          elem_zero.attr('data-aos-duration', 1500);
          elem_zero.attr('data-aos-once', 'true');
          
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');
    
          elem_second.attr('data-aos', 'fade-up');
          elem_second.attr('data-aos-duration', 1500);
          elem_second.attr('data-aos-once', 'true');

          setTimeout(() => {
              AOS.init();
          });
        });

        var ghee_product_section = "#shopify-section-template--21038767505701__5ebff2f0-27a5-467d-9378-2cd62df1995a";
        $(ghee_product_section).each(function() {
          
          var elem_zero = $(`${ghee_product_section} .sub-title`);
          var elem_first = $(`${ghee_product_section} .title`);
          var elem_second = $(`${ghee_product_section} .ishi-featured-product-tab`);
        
          // Set the data-aos-duration attribute
          elem_zero.attr('data-aos', 'fade-up');
          elem_zero.attr('data-aos-duration', 1500);
          elem_zero.attr('data-aos-once', 'true');
          
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');
    
          elem_second.attr('data-aos', 'fade-up');
          elem_second.attr('data-aos-duration', 1500);
          elem_second.attr('data-aos-once', 'true');

          setTimeout(() => {
              AOS.init();
          });
        });

        var coco_gift_section = "#shopify-section-template--21038767472933__7282d07c-aa00-45ae-be70-34a000600f59";
        $(coco_gift_section).each(function() {
          
          var elem_zero = $(`${coco_gift_section} .sub-title`);
          var elem_first = $(`${coco_gift_section} .title`);
          var elem_second = $(`${coco_gift_section} .ishi-featured-product-tab`);
        
          // Set the data-aos-duration attribute
          elem_zero.attr('data-aos', 'fade-up');
          elem_zero.attr('data-aos-duration', 1500);
          elem_zero.attr('data-aos-once', 'true');
          
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');
    
          elem_second.attr('data-aos', 'fade-up');
          elem_second.attr('data-aos-duration', 1500);
          elem_second.attr('data-aos-once', 'true');

          setTimeout(() => {
              AOS.init();
          });
        });

        var coco_product_section = "#shopify-section-template--21038767472933__5ebff2f0-27a5-467d-9378-2cd62df1995a";
        $(coco_product_section).each(function() {
          
          var elem_zero = $(`${coco_product_section} .sub-title`);
          var elem_first = $(`${coco_product_section} .title`);
          var elem_second = $(`${coco_product_section} .ishi-featured-product-tab`);
        
          // Set the data-aos-duration attribute
          elem_zero.attr('data-aos', 'fade-up');
          elem_zero.attr('data-aos-duration', 1500);
          elem_zero.attr('data-aos-once', 'true');
          
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');
    
          elem_second.attr('data-aos', 'fade-up');
          elem_second.attr('data-aos-duration', 1500);
          elem_second.attr('data-aos-once', 'true');

          setTimeout(() => {
              AOS.init();
          });
        });

         var almond_gift_section = "#shopify-section-template--21038767407397__7282d07c-aa00-45ae-be70-34a000600f59";
        $(almond_gift_section).each(function() {
          
          var elem_zero = $(`${almond_gift_section} .sub-title`);
          var elem_first = $(`${almond_gift_section} .title`);
          var elem_second = $(`${almond_gift_section} .ishi-featured-product-tab`);
        
          // Set the data-aos-duration attribute
          elem_zero.attr('data-aos', 'fade-up');
          elem_zero.attr('data-aos-duration', 1500);
          elem_zero.attr('data-aos-once', 'true');
          
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');
    
          elem_second.attr('data-aos', 'fade-up');
          elem_second.attr('data-aos-duration', 1500);
          elem_second.attr('data-aos-once', 'true');

          setTimeout(() => {
              AOS.init();
          });
        });

         var almond_product_section = "#shopify-section-template--21038767407397__5ebff2f0-27a5-467d-9378-2cd62df1995a";
        $(almond_product_section).each(function() {
          
          var elem_zero = $(`${almond_product_section} .sub-title`);
          var elem_first = $(`${almond_product_section} .title`);
          var elem_second = $(`${almond_product_section} .ishi-featured-product-tab`);
        
          // Set the data-aos-duration attribute
          elem_zero.attr('data-aos', 'fade-up');
          elem_zero.attr('data-aos-duration', 1500);
          elem_zero.attr('data-aos-once', 'true');
          
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');
    
          elem_second.attr('data-aos', 'fade-up');
          elem_second.attr('data-aos-duration', 1500);
          elem_second.attr('data-aos-once', 'true');

          setTimeout(() => {
              AOS.init();
          });
        });

        var sesame_gift_section = "#shopify-section-template--21038767571237__7282d07c-aa00-45ae-be70-34a000600f59";
        $(sesame_gift_section).each(function() {
          
          var elem_zero = $(`${sesame_gift_section} .sub-title`);
          var elem_first = $(`${sesame_gift_section} .title`);
          var elem_second = $(`${sesame_gift_section} .ishi-featured-product-tab`);
        
          // Set the data-aos-duration attribute
          elem_zero.attr('data-aos', 'fade-up');
          elem_zero.attr('data-aos-duration', 1500);
          elem_zero.attr('data-aos-once', 'true');
          
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');
    
          elem_second.attr('data-aos', 'fade-up');
          elem_second.attr('data-aos-duration', 1500);
          elem_second.attr('data-aos-once', 'true');

          setTimeout(() => {
              AOS.init();
          });
        });

        var sesame_product_section = "#shopify-section-template--21038767571237__5ebff2f0-27a5-467d-9378-2cd62df1995a";
        $(sesame_product_section).each(function() {
          
          var elem_zero = $(`${sesame_product_section} .sub-title`);
          var elem_first = $(`${sesame_product_section} .title`);
          var elem_second = $(`${sesame_product_section} .ishi-featured-product-tab`);
        
          // Set the data-aos-duration attribute
          elem_zero.attr('data-aos', 'fade-up');
          elem_zero.attr('data-aos-duration', 1500);
          elem_zero.attr('data-aos-once', 'true');
          
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');
    
          elem_second.attr('data-aos', 'fade-up');
          elem_second.attr('data-aos-duration', 1500);
          elem_second.attr('data-aos-once', 'true');

          setTimeout(() => {
              AOS.init();
          });
        });

        var black_musturd_gift_section = "#shopify-section-template--21038767440165__7282d07c-aa00-45ae-be70-34a000600f59";
        $(black_musturd_gift_section).each(function() {
          
          var elem_zero = $(`${black_musturd_gift_section} .sub-title`);
          var elem_first = $(`${black_musturd_gift_section} .title`);
          var elem_second = $(`${black_musturd_gift_section} .ishi-featured-product-tab`);
        
          // Set the data-aos-duration attribute
          elem_zero.attr('data-aos', 'fade-up');
          elem_zero.attr('data-aos-duration', 1500);
          elem_zero.attr('data-aos-once', 'true');
          
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');
    
          elem_second.attr('data-aos', 'fade-up');
          elem_second.attr('data-aos-duration', 1500);
          elem_second.attr('data-aos-once', 'true');

          setTimeout(() => {
              AOS.init();
          });
        });

        var black_musturd_product_section = "#shopify-section-template--21038767440165__5ebff2f0-27a5-467d-9378-2cd62df1995a";
        $(black_musturd_product_section).each(function() {
          
          var elem_zero = $(`${black_musturd_product_section} .sub-title`);
          var elem_first = $(`${black_musturd_product_section} .title`);
          var elem_second = $(`${black_musturd_product_section} .ishi-featured-product-tab`);
        
          // Set the data-aos-duration attribute
          elem_zero.attr('data-aos', 'fade-up');
          elem_zero.attr('data-aos-duration', 1500);
          elem_zero.attr('data-aos-once', 'true');
          
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');
    
          elem_second.attr('data-aos', 'fade-up');
          elem_second.attr('data-aos-duration', 1500);
          elem_second.attr('data-aos-once', 'true');

          setTimeout(() => {
              AOS.init();
          });
        });

        var yellow_musturd_gift_section = "shopify-section-template--21038767604005__7282d07c-aa00-45ae-be70-34a000600f59";
        $(yellow_musturd_gift_section).each(function() {
          
          var elem_zero = $(`${yellow_musturd_gift_section} .sub-title`);
          var elem_first = $(`${yellow_musturd_gift_section} .title`);
          var elem_second = $(`${yellow_musturd_gift_section} .ishi-featured-product-tab`);
        
          // Set the data-aos-duration attribute
          elem_zero.attr('data-aos', 'fade-up');
          elem_zero.attr('data-aos-duration', 1500);
          elem_zero.attr('data-aos-once', 'true');
          
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');
    
          elem_second.attr('data-aos', 'fade-up');
          elem_second.attr('data-aos-duration', 1500);
          elem_second.attr('data-aos-once', 'true');

          setTimeout(() => {
              AOS.init();
          });
        });

        var yellow_musturd_product_section = "shopify-section-template--21038767604005__5ebff2f0-27a5-467d-9378-2cd62df1995a";
        $(yellow_musturd_product_section).each(function() {
          
          var elem_zero = $(`${yellow_musturd_product_section} .sub-title`);
          var elem_first = $(`${yellow_musturd_product_section} .title`);
          var elem_second = $(`${yellow_musturd_product_section} .ishi-featured-product-tab`);
        
          // Set the data-aos-duration attribute
          elem_zero.attr('data-aos', 'fade-up');
          elem_zero.attr('data-aos-duration', 1500);
          elem_zero.attr('data-aos-once', 'true');
          
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');
    
          elem_second.attr('data-aos', 'fade-up');
          elem_second.attr('data-aos-duration', 1500);
          elem_second.attr('data-aos-once', 'true');

          setTimeout(() => {
              AOS.init();
          });
        });

        var default_gift_section = "#shopify-section-template--21038767538469__8ff24031-6337-4d49-a640-bea2f3880350";
        $(default_gift_section).each(function() {
          
          var elem_zero = $(`${default_gift_section} .sub-title`);
          var elem_first = $(`${default_gift_section} .title`);
          var elem_second = $(`${default_gift_section} .ishi-featured-product-tab`);
        
          // Set the data-aos-duration attribute
          elem_zero.attr('data-aos', 'fade-up');
          elem_zero.attr('data-aos-duration', 1500);
          elem_zero.attr('data-aos-once', 'true');
          
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');
    
          elem_second.attr('data-aos', 'fade-up');
          elem_second.attr('data-aos-duration', 1500);
          elem_second.attr('data-aos-once', 'true');

          setTimeout(() => {
              AOS.init();
          });
        });

        // function initializeAOS(sectionId) {
        //   var section = $(sectionId);
          
        //   var elem_zero = $(`${sectionId} .sub-title`);
        //   var elem_first = $(`${sectionId} .title`);
        //   var elem_second = $(`${sectionId} .ishi-featured-product-tab`);
        
        //   // Set the data-aos-duration attribute
        //   elem_zero.attr('data-aos', 'fade-up');
        //   elem_zero.attr('data-aos-duration', 1500);
        //   elem_zero.attr('data-aos-once', 'true');
          
        //   elem_first.attr('data-aos', 'fade-up');
        //   elem_first.attr('data-aos-duration', 1500);
        //   elem_first.attr('data-aos-once', 'true');
    
        //   elem_second.attr('data-aos', 'fade-up');
        //   elem_second.attr('data-aos-duration', 1500);
        //   elem_second.attr('data-aos-once', 'true');
        
        //   setTimeout(() => {
        //     AOS.init();
        //   });
        // }
    
        // var ghee_gift_section = "#shopify-section-template--21038767505701__7282d07c-aa00-45ae-be70-34a000600f59";
        // initializeAOS(ghee_gift_section);
    
        // var ghee_product_section = "#shopify-section-template--21038767505701__5ebff2f0-27a5-467d-9378-2cd62df1995a";
        // initializeAOS(ghee_product_section);
    
        // var coco_gift_section = "#shopify-section-template--21038767472933__7282d07c-aa00-45ae-be70-34a000600f59";
        // initializeAOS(coco_gift_section);
    
        // var coco_product_section = "#shopify-section-template--21038767472933__5ebff2f0-27a5-467d-9378-2cd62df1995a";
        // initializeAOS(coco_product_section);
    
        // var almond_gift_section = "#shopify-section-template--21038767407397__7282d07c-aa00-45ae-be70-34a000600f59";
        // initializeAOS(almond_gift_section);
    
        // var almond_product_section = "#shopify-section-template--21038767407397__5ebff2f0-27a5-467d-9378-2cd62df1995a";
        // initializeAOS(almond_product_section);
    
        // var sesame_gift_section = "#shopify-section-template--21038767571237__7282d07c-aa00-45ae-be70-34a000600f59";
        // initializeAOS(sesame_gift_section);
    
        // var sesame_product_section = "#shopify-section-template--21038767571237__5ebff2f0-27a5-467d-9378-2cd62df1995a";
        // initializeAOS(sesame_product_section);
    
        // var black_musturd_gift_section = "#shopify-section-template--21038767440165__7282d07c-aa00-45ae-be70-34a000600f59";
        // initializeAOS(black_musturd_gift_section);
    
        // var black_musturd_product_section = "#shopify-section-template--21038767440165__5ebff2f0-27a5-467d-9378-2cd62df1995a";
        // initializeAOS(black_musturd_product_section);
    
        // var yellow_musturd_gift_section = "#shopify-section-template--21038767440165__7282d07c-aa00-45ae-be70-34a000600f59";
        // initializeAOS(yellow_musturd_gift_section);
    
        // var yellow_musturd_product_section = "#shopify-section-template--21038767440165__5ebff2f0-27a5-467d-9378-2cd62df1995a";
        // initializeAOS(yellow_musturd_product_section);
    
        // var default_gift_section = "#shopify-section-template--21038767538469__8ff24031-6337-4d49-a640-bea2f3880350";
        // initializeAOS(default_gift_section);
  
      });

      // about-banner

      var packaging_section = "#shopify-section-template--21038767243557__557bfee8-33e1-4f69-8be9-be1a62f4603d";
      $(packaging_section).each(function() {
        var elem_first = $(`${packaging_section} .aboutus-information`);
        // Set the data-aos-duration attribute
        elem_first.attr('data-aos', 'fade-up');
        elem_first.attr('data-aos-duration', 1500);
        elem_first.attr('data-aos-once', 'true');

        setTimeout(() => {
            AOS.init();
        });
      });
    var packaging_section = "#shopify-section-template--21520726786341__76823f8b-374d-4951-a4ce-9d1d0086fe25";
      $(packaging_section).each(function() {
        var elem_first = $(`${packaging_section} .aboutus-information`);
        // Set the data-aos-duration attribute
        elem_first.attr('data-aos', 'fade-up');
        elem_first.attr('data-aos-duration', 1500);
        elem_first.attr('data-aos-once', 'true');

        setTimeout(() => {
            AOS.init();
        });
      });
    var mill_section = "#shopify-section-template--21038767309093__76a4a591-0de5-454a-86f2-1c77faf54fa2";
        $(mill_section).each(function() {
          var elem_first = $(`${mill_section} .aboutus-information`);
          // Set the data-aos-duration attribute
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');
          elem_first.attr('data-aos-offset', '100');

          setTimeout(() => {
              AOS.init();
          });
        });

      var farms_richtext = "#shopify-section-template--21038767276325__b4581707-cd01-4a3c-bf8f-544f842d57e8";
        $(farms_richtext).each(function() {
          var elem_first = $(`${farms_richtext} .rich-text`);
          // Set the data-aos-duration attribute
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');

          setTimeout(() => {
              AOS.init();
          });
        });

      var oil_production_text = "#shopify-section-template--21038767309093__5d830522-5bc7-4c9b-9800-dd4648263f7a";
        $(oil_production_text).each(function() {
          var elem_first = $(`${oil_production_text} .rich-text`);
          // Set the data-aos-duration attribute
          elem_first.attr('data-aos', 'fade-up');
          elem_first.attr('data-aos-duration', 1500);
          elem_first.attr('data-aos-once', 'true');

          setTimeout(() => {
              AOS.init();
          });
        });
